import React from 'react';
import SmsActionIcon from '../../../../../ui/icons/SMSAction/SmsAction';
import { NotificationPreferences } from '../../../../../../../../__generated__/loma';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import { LayoutTree } from '../../../../DynamicLayout';
import SMSOptInForm from './SMSOptInForm';
import { Channels } from '../../../types';
import OptInTemplate from '../OptInTemplate';
import { ERROR_TYPES } from '../../..';

export interface OptInProps {
  onOptIn: (
    contactInfo: string,
    retailerLevel: boolean,
    savePreferencesChecked?: boolean,
    marketingOptInChecked?: boolean,
  ) => void;
  onChange: () => void;
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
  channel: Channels;
  validationError?: ERROR_TYPES;
  notificationPreferencesState?: NotificationPreferences;
  consumerPreferencesOptinEnabled?: boolean;
  retailerMarketingOptinEnabled?: boolean;
}

export interface OptInChannelProps {
  optInChannelInput: React.ReactNode;
  optInIcon: React.ReactNode;
  optInMessageText: string;
}

const OptIn = ({
  featureName,
  layout,
  onOptIn,
  onChange,
  channel,
  validationError,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled,
  retailerMarketingOptinEnabled,
}: OptInProps) => {
  const { notificationCenterSmsOptinMessage } = useTranslations();

  const smsOptInChannelProps: OptInChannelProps = {
    optInChannelInput: (
      <SMSOptInForm
        onOptIn={onOptIn}
        onChange={onChange}
        validationError={validationError}
        layout={layout}
        featureName={featureName}
        notificationPreferencesState={notificationPreferencesState}
        consumerPreferencesOptinEnabled={consumerPreferencesOptinEnabled}
        retailerMarketingOptinEnabled={retailerMarketingOptinEnabled}
      />
    ),
    optInIcon: <SmsActionIcon />,
    optInMessageText: notificationCenterSmsOptinMessage || '',
  };

  return (
    <OptInTemplate
      featureName={featureName}
      layout={layout}
      channel={channel}
      optInChannelProps={smsOptInChannelProps}
      consumerPreferencesOptinEnabled={consumerPreferencesOptinEnabled}
    />
  );
};

export default OptIn;
